import { render, staticRenderFns } from "./my-tc.vue?vue&type=template&id=3a076c2c&"
import script from "./my-tc.vue?vue&type=script&lang=js&"
export * from "./my-tc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports